/* eslint-disable no-undef */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react'
import { useRecoilState } from 'recoil'
import {
  PageHeader, Row, Col, Upload, Button, Table, Divider, Input, Space, Typography, message,
} from 'antd'
import { UploadOutlined, DownloadOutlined, SearchOutlined } from '@ant-design/icons'
import NumberFormat from 'react-number-format'
import moment from 'moment'
import Cookies from 'js-cookie'

import { format } from 'date-fns'

import { fetch, fetchDownload } from '../../utils/fetch'

import { userState } from '../../store/atoms'

const endpoint = process.env[`REACT_APP_ENDPOINT_${process.env.REACT_APP_ENV}`]

const { Text } = Typography

const ArticleStandardPrice = ({ name }) => {
  const [articleList, setArticleList] = useState([])
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [loading, setLoading] = useState(false)
  const [user] = useRecoilState(userState)
  const inputRef = useRef()

  const getDataArticleStandardPrice = () => {
    setLoading(true)
    fetch({
      url: '/management/articleStandardPrice',
    }).then((res) => {
      if (res.data?.success) {
        setArticleList(res.data?.data)
      }
      setLoading(false)
    })
  }

  const DownloadArticleStandardPrice = () => {
    setLoading(true)
    fetchDownload({
      url: '/management/articleStandardPrice/download',
      fileName: `articleStandard_${format(new Date(), 'dd-MM-yyyy')}.xlsx`,
    }).then((res) => {
      if (res.success) {
        message.success('Download Success')
      } else {
        message.error(res.message)
      }
    })
    setLoading(false)
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          id="search-input"
          ref={inputRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            id="search-search-btn"
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button id="search-reset-btn" onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
          <Button
            id="search-filter-btn"
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false })
              setSearchText(selectedKeys[0])
              setSearchedColumn(dataIndex)
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => (record[dataIndex]
      ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
      : ''),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => inputRef.current.input.focus(), 100)
      }
    },
    render: (text) => text,
  })

  const uploadProps = {
    name: 'file',
    action: `${endpoint}/management/articleStandardPrice/upload`,
    accept: 'application/xlsx',
    headers: {
      authorization: Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`),
    },
    onChange(info) {
      setLoading(true)
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
        setLoading(false)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        getDataArticleStandardPrice()
        setLoading(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setLoading(false)
      }
    },
    showUploadList: false,
  }

  const columns = [
    {
      title: 'Article',
      dataIndex: 'articleNo',
      key: 'articleNo',
      width: 100,
      ...getColumnSearchProps('articleNo'),

      sorter: (a, b) => a.articleNo - b.articleNo,
    },
    {
      title: `Price${user?.country?.currency && ` (${user?.country?.currency})`}`,
      dataIndex: 'price',
      key: 'price',
      width: 100,
      render: (value) => <NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" value={value || 0} />,
    },
    {
      title: 'Updated By',
      dataIndex: 'updatedBy',
      key: 'updatedBy',
      width: 100,
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 100,
      render: (value) => value && moment(new Date(value)).format('DD/MM/YYYY HH:mm'),
    },
  ]

  useEffect(() => {
    getDataArticleStandardPrice()
  }, [])

  return (
    <>
      <PageHeader
        ghost={false}
        title={<>{name} {user?.country?.descr && <Text id="text-country" keyboard>{user?.country?.descr}</Text>}</>}
        extra={(
          <Row gutter={[16]}>
            <Col>
              <Upload {...uploadProps}>
                <Button id="upload-btn" icon={<UploadOutlined />} type="primary">Upload</Button>
              </Upload>
            </Col>
            <Col>
              <Button id="download-btn" icon={<DownloadOutlined />} onClick={() => DownloadArticleStandardPrice()}>Download</Button>
            </Col>
          </Row>
        )}
      >
        <Divider />
        <Row style={{ marginBottom: 20 }}>
          <Col>
            Total record(s): {articleList.length}
          </Col>
        </Row>
        <Table dataSource={articleList} size="small" columns={columns} rowKey={(record) => `row-${record.articleNo}`} />
      </PageHeader>
    </>
  )
}

export default ArticleStandardPrice
